<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createCoverForm">
      <div class="row mt-3">
        <div class="col-12 custom-form-label px-0">
          {{$t('name')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col px-0">
          
          <input v-model="name" type="text" id="txtCovname" v-bind:placeholder="$store.translate('name')" maxlength="200" class="form-control" />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 custom-form-label px-0">
          {{$t('description')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 px-0">
          <mce-editor toolbar="undo redo | styleselect | outdent indent backcolor fontselect fontsizeselect forecolor" v-bind:doinit="false" ref="mce" value="" name="something"></mce-editor>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 custom-form-label px-0">
          {{$t('introduction_image')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col px-0">
          <!--<input-text type="text" v-bind:placeholder="$t('introduction_image')" v-model="introduction_image" style="font-size:18px;"></input-text>-->
          <file-selector @delete_file="deleteFile" filter="jpg,jpeg,png,gif" ref="fileSelctorIntroImage"></file-selector>
        </div>
      </div>      
      <div class="row mt-3">
        <div class="col-lg-12 form-group pt-3 px-0">
          <a style="color:inherit" @click="doSaveCover" class="btn btn-link skin btn-primary pull-right">{{$t('update')}}</a>
          <a style="color:inherit" @click="cancel" class="btn skin btn-link pull-right mr-1">{{$t('cancel')}}</a>
        </div>
      </div>

      <div class="row mt-3">
        <container-expand-right v-bind:title="$t('introduction_file')" class="p-0">
          <div class="container-fluid p-3">
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('file_name')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <input v-model="file_name" type="text" id="file_name" v-bind:placeholder="$store.translate('name')" maxlength="200" name="txtCovname" class="form-control" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('file_description')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <!--<input-text type="text" v-bind:placeholder="$t('description')" v-model="file_description" style="font-size:18px;"></input-text>-->
                <mce-editor toolbar="undo redo | styleselect | outdent indent backcolor fontselect fontsizeselect forecolor" v-bind:doinit="false" ref="mcefiledesc" value="" name="descriptionfile"></mce-editor>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('introduction_file')}} (Powerpoint/pdf)
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <!--<input-text type="text" v-bind:placeholder="$t('introduction_file')" v-model="introduction_file" style="font-size:18px;"></input-text>-->
                <file-selector  @delete_file="deleteFile" filter="ppt,pdf,doc,docx,pptx" ref="fileSelctorIntrofile"></file-selector>
              </div>
            </div>
          </div>
        </container-expand-right>
      </div>

      <div class="row mt-3">
        <container-expand-right v-bind:title="$t('general_information')" class="p-0">
          <div class="container-fluid p-3">

          </div>
        </container-expand-right>
      </div>

      <div class="row mt-3">
        <container-expand-right v-bind:title="$t('bio')" class="p-0">
          <div class="container-fluid p-3">
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('bio_image')}}
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                <file-selector @delete_file="deleteFile" filter="jpg,jpeg,png,gif" ref="bioSelctorIntroImage"></file-selector>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('admin_name')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <input-text type="text" v-bind:placeholder="$t('name')" v-model="bio_name" style="font-size:18px;"></input-text>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('bio')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-12 px-0">
                <mce-editor toolbar="undo redo | styleselect | outdent indent backcolor fontselect fontsizeselect forecolor" v-bind:doinit="false" ref="mcebiodesc" value="" name="descriptionbio"></mce-editor>
              </div>
            </div>


            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('email')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <input v-model="bioemail" type="text" id="txtbioemail" v-bind:placeholder="$store.translate('email')" maxlength="200" name="txtbioemail" class="form-control" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('telephone')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <input v-model="biotelephone" type="text" id="txtbiotelephone" v-bind:placeholder="$store.translate('telephone')" maxlength="50" name="txtbiotelephone" class="form-control" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('skype')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <input v-model="bioskype" type="text" id="txtbioskype" v-bind:placeholder="$store.translate('skype')" maxlength="50" name="txtbioskype" class="form-control" />
              </div>
            </div>
          </div>
        </container-expand-right>
      </div>
    </form>
  </div>

</template>

<script>
  var coverImgId = 0;
  var coverFileId = 0;
  var bioFileId = 0;
  export default {
    name: "cover-editor",
    components: {

    },
    props: {
      filter: {
        required: false,
        type: String,
        default: null,
      },
    },
    data() {
      return {
        name: '',
        description: '',

        admin_name: '',
        admin_bio: '',
        coverImgId: 0,
        coverFileId: 0,
        bioFileId: 0,
        bio_name: '',
        bio_description: '',
        file_name: '',
        file_description: '',
        bioskype: '',
        biotelephone: '',
        bioemail: '',
      };
    },
    methods: {
      deleteFile(fileId) {
        if (fileId === this.coverImgId)
          this.coverImgId = 0;
        else if (fileId === this.coverFileId)
          this.coverFileId = 0;
        else if (fileId === this.bioFileId)
          this.bioFileId = 0;
      },
      cancel() {
        this.$emit("cancel", "cover")
        this.$root.$emit("cancel_cover")
      },
      async doSaveCover() {
        try {
          if (!$('#createCoverForm').valid())
            return false;
          let formData = new FormData();
          if (this.$refs.fileSelctorIntroImage.selectedFiles != undefined && this.$refs.fileSelctorIntroImage.selectedFiles.length > 0) {
            formData.append("fileimg", this.$refs.fileSelctorIntroImage.selectedFiles[0]);
          }


          if (this.$refs.bioSelctorIntroImage.selectedFiles != undefined && this.$refs.bioSelctorIntroImage.selectedFiles.length > 0) {
            formData.append("filebio", this.$refs.bioSelctorIntroImage.selectedFiles[0]);
          }


          if (this.$refs.fileSelctorIntrofile.selectedFiles != undefined && this.$refs.fileSelctorIntrofile.selectedFiles.length > 0) {
            formData.append("fileintro", this.$refs.fileSelctorIntrofile.selectedFiles[0]);
          }

          formData.append("description", this.$refs.mce.getValue());
          formData.append("name", this.name);


          formData.append("coverImgId", this.coverImgId);
          formData.append("coverFileId", this.coverFileId);
          formData.append("bioFileId", this.bioFileId);
          
          formData.append("bio_name", this.bio_name);
          formData.append("bio_description", this.$refs.mcebiodesc.getValue()); //this.bio_description);
          formData.append("file_name", this.file_name);
          formData.append("file_description", this.$refs.mcefiledesc.getValue());//this.file_description);

          formData.append("bioskype", this.bioskype);
          formData.append("biotelephone", this.biotelephone);
          formData.append("bioemail", this.bioemail);

          var response = await this.$http.post(
            '/api/site/CoverSave',
            formData
          ).then(async response => {
            getNewsCovertitle();
            var data = response.data;

            console.log(data);
            this.coverImgId = data.coverImgId;
            this.coverFileId = data.coverFileId;
            this.bioFileId = data.bioFileId;
            this.$refs.fileSelctorIntrofile.loadFile(data.coverIntroUrl, data.coverIntroName, true);
            this.$refs.fileSelctorIntroImage.loadFile(data.coverImgUrl, data.coverImgName, true);
            this.$refs.bioSelctorIntroImage.loadFile(data.coverBioImageUrl, data.coverBioName, true);
          });

        } catch (err) {

        }
      },
      async getCover() {
        try {
          this.$http.get('/api/Site/GetSiteCover').then(async response => {
            var cover = response.data;
            console.log(cover);
            //alert("setting value:" + cover.CoverDescription)
            this.$refs.mce.setValue(cover.CoverDescription);
            this.name = cover.CoverName;
            this.coverImgId = cover.coverImgId;
            this.coverFileId = cover.coverFileId;
            this.bioFileId = cover.bioFileId;
            this.$refs.fileSelctorIntrofile.loadFile(cover.coverIntroUrl, cover.coverIntroName, true);
            this.$refs.fileSelctorIntroImage.loadFile(cover.coverImgUrl, cover.coverImgName, true);

            this.$refs.bioSelctorIntroImage.loadFile(cover.coverBioImageUrl, cover.coverBioImageName, true);
            this.bio_name = cover.coverBioName;
            //this.bio_description = cover.coverBioDescription;
            this.$refs.mcebiodesc.setValue(cover.coverBioDescription);
            this.file_name = cover.coverFileName;
            //this.file_description = cover.coverFileDescription;
            this.$refs.mcefiledesc.setValue(cover.coverFileDescription);

            //$(".newsnav").text(this.name);
            this.bioskype = cover.CoverBioSkype;
            this.biotelephone = cover.CoverBioTelephone;
            this.bioemail = cover.CoverBioEmail;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        var isLoggedIn = this.$store.isLoggedIn();
        if (isLoggedIn) {
          this.getCover();
        }
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/startpage/cover-editor.vue